import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { ForYou } from './components/ForYou';
import { WhatItIs } from './components/WhatItIs';
import { Tomos } from './components/Tomos';
import { Included } from './components/Included';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchaseProofPopup } from './components/PurchaseProofPopup';
import { initMetaPixel } from './lib/pixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream-50" data-id="element-0" data-mp="28suu8n3mnxlq">
      <main className="w-full" data-id="element-1" data-mp="23vchelmhoy8g">
        <Hero data-id="element-2" data-mp="23w4clvc6cty7" />
        <Stats data-id="element-3" data-mp="23ujlygszdv5m" />
        <ForYou data-id="element-4" data-mp="23v2rsz5cwt3a" />
        <WhatItIs data-id="element-5" data-mp="23ti864kkyuk7" />
        <Tomos data-id="element-6" data-mp="3ik7fqfdqo9q4" />
        <Included data-id="element-7" data-mp="3ikqzm1my986s" />
        <Bonuses data-id="element-8" data-mp="3ij64a9st9l7v" />
        <Offer data-id="element-9" data-mp="3ijpcgysnsv8p" />
        <Guarantee data-id="element-10" data-mp="3ii4t85bsoyq5" />
        <Testimonials data-id="element-11" data-mp="3mlavl1vse5rc" />
        <FinalCta data-id="element-12" data-mp="3mkrcviybbdc9" />
      </main>
      <Footer data-id="element-13" data-mp="3mjq1fdddwou0" />
      <FloatingCta triggerId="cta-hero" data-id="element-14" data-mp="3mjg8pi0yg3km" />
      <PurchaseProofPopup data-id="element-15" data-mp="3rbzn2h7gv2qh" />
    </div>;
}